const env = import.meta.env || {};

export const API_BASE_URL = (env.API_Base_URL || "https://admin.mbsmw.org").replace(/\/+$/, "");

export const apiUrl = (path = "") => {
  if (!path) return API_BASE_URL;
  if (/^https?:\/\//i.test(path)) return path;

  return `${API_BASE_URL}/${String(path).replace(/^\/+/, "")}`;
};
